// Departamentos de Uruguay y sus ciudades/localidades más conocidas.
// No es un registro exhaustivo de todas las localidades del país: cubre
// la capital departamental y las ciudades/pueblos más habitados o
// conocidos de cada departamento, suficiente para envíos de pedidos.
const UY_LOCATIONS = {
  Artigas: ['Artigas', 'Bella Unión', 'Baltasar Brum', 'Tomás Gomensoro'],
  Canelones: [
    'Canelones',
    'Las Piedras',
    'Pando',
    'La Paz',
    'Santa Lucía',
    'Progreso',
    'Ciudad de la Costa',
    'Barros Blancos',
    'Atlántida',
    'Salinas',
    'Sauce',
    'Toledo',
    'Tala',
    'Empalme Olmos',
    'Migues',
  ],
  'Cerro Largo': ['Melo', 'Río Branco', 'Fraile Muerto', 'Isidoro Noblía'],
  Colonia: [
    'Colonia del Sacramento',
    'Carmelo',
    'Nueva Helvecia',
    'Juan Lacaze',
    'Rosario',
    'Tarariras',
    'Nueva Palmira',
    'Conchillas',
  ],
  Durazno: ['Durazno', 'Sarandí del Yí', 'Villa del Carmen', 'La Paloma'],
  Flores: ['Trinidad', 'Ismael Cortinas'],
  Florida: ['Florida', 'Sarandí Grande', 'Casupá', 'Cerro Colorado'],
  Lavalleja: ['Minas', 'José Pedro Varela', 'Solís de Mataojo', 'Mariscala'],
  Maldonado: [
    'Maldonado',
    'Punta del Este',
    'San Carlos',
    'Piriápolis',
    'Pan de Azúcar',
    'Aiguá',
  ],
  Montevideo: ['Montevideo'],
  Paysandú: ['Paysandú', 'Guichón', 'Quebracho', 'Porvenir'],
  'Río Negro': ['Fray Bentos', 'Young', 'San Javier', 'Nuevo Berlín'],
  Rivera: ['Rivera', 'Tranqueras', 'Vichadero', 'Minas de Corrales'],
  Rocha: ['Rocha', 'Chuy', 'Castillos', 'La Paloma', 'Lascano', '18 de Julio'],
  Salto: ['Salto', 'Constitución', 'Belén', 'Daymán'],
  'San José': ['San José de Mayo', 'Ciudad del Plata', 'Libertad', 'Rodríguez', 'Ecilda Paullier'],
  Soriano: ['Mercedes', 'Dolores', 'Cardona', 'José Enrique Rodó'],
  Tacuarembó: ['Tacuarembó', 'Paso de los Toros', 'Ansina', 'Curtina'],
  'Treinta y Tres': ['Treinta y Tres', 'Vergara', 'Santa Clara de Olimar'],
};

export const UY_DEPARTMENTS = Object.keys(UY_LOCATIONS);

export const getCitiesForDepartment = (department) => UY_LOCATIONS[department] || [];

const stripAccents = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');

export const findDepartmentMatch = (rawDepartment) => {
  const normalized = stripAccents(rawDepartment);
  if (!normalized) return null;
  return UY_DEPARTMENTS.find((dept) => stripAccents(dept) === normalized) || null;
};

export const findCityMatch = (rawCity, department) => {
  const normalized = stripAccents(rawCity);
  if (!normalized) return null;
  const cities = getCitiesForDepartment(department);
  return cities.find((city) => stripAccents(city) === normalized) || null;
};

export default UY_LOCATIONS;
